import React from 'react'
import StandBy from '../../components/common/StandBy'

function EntrenamientoInfo() {
    return (
         <StandBy />
    )
}

export default EntrenamientoInfo